module.exports = __webpack_public_path__ + "img/id-verified.ef120c51.png";